var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge"},[_c('vs-chip',{staticClass:"pt-0 pb-0 pr-2 pl-2",attrs:{"color":_vm.status ? 'success' : 'primary'},domProps:{"textContent":_vm._s(_vm.status ? _vm.$tc('transfer') : _vm.$tc('untransfer'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }